import "cn-next/es/loading/style";
import _Loading from "cn-next/es/loading";

/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
var loadingSetter;

function LoadingComp() {
  var _useState = useState(false),
      visible = _useState[0],
      setVisible = _useState[1];

  loadingSetter = setVisible;
  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_Loading, {
    visible: visible,
    fullScreen: true,
    shape: "fusion-reactor"
  }));
}

var timer = null;
var loadingNode; // 显示全局 loading

export var showLoading = function showLoading(delay) {
  if (delay === void 0) {
    delay = 300;
  }

  if (timer) {
    clearTimeout(timer);
    timer = null;
  }

  loadingNode = document.createElement('div');
  loadingNode.setAttribute('id', 'full#loading');
  document.body.appendChild(loadingNode);
  timer = setTimeout(function () {
    ReactDOM.render( /*#__PURE__*/React.createElement(LoadingComp, null), document.getElementById('full#loading'));
    if (typeof loadingSetter === 'function') loadingSetter(true);
  }, delay);
}; // 隐藏 loading

export var hideLoading = function hideLoading() {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }

  if (loadingSetter instanceof Function) loadingSetter(false);
};